module.exports = __webpack_public_path__ + "img/icon_dzf.dc79a85d.svg";